import { render, staticRenderFns } from "./EventsRenderer.vue?vue&type=template&id=e371bcc2"
import script from "./EventsRenderer.vue?vue&type=script&lang=js"
export * from "./EventsRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports